const Data = [
    {
        name: "Amisha Rathi",
        position: "Rise Head",
        imageUrl: "/assets/images/members/Heads23/Amisha Rathi.jpeg",
        facebookLink: "https://www.facebook.com/amisha.rathi.545?mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/amisha-rathi?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "amisha.r@gyws.org"
    },
    {
        name: "K Janaki Ratna Lakshmi ",
        position: "Rise Head",
        imageUrl: "/assets/images/members/Heads23/Janaki Kusumanchi.jpg",
        facebookLink: "https://www.facebook.com/JaanuJanaki8710/",
        linkedinLink: "https://www.linkedin.com/in/janaki-kusumanchi-161388250?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "k.lakshmi@gyws.org"
    },
]

export default Data;